"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFragment = exports.StepsContainer = exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _StyledFeatures = require("./StyledFeatures");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Container = exports.Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    prefixCls = _ref.prefixCls;
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledFragment, {
    theme: theme,
    prefixCls: prefix
  }, children(prefix));
};
var StyledFragment = exports.StyledFragment = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-yafiiu-0"
})([".", "{width:100%;line-height:1.5;display:flex;padding:", ";background-color:", ";border:", ";justify-content:center;}.", "-item{position:relative;flex:1;display:block;align-items:center;overflow:hidden;flex-direction:column;&-container{flex:1;display:flex;align-items:center;overflow:hidden;flex-direction:column;&[role='button']:hover{cursor:pointer;transition:background-color,border-color 0.3s;.", "-item-icon{background-color:", ";border-color:", ";}}}&:last-child .", "-item-tail,&:last-child .", "-item-title:after{display:none;}&-icon,&-content{display:inline-block;vertical-align:top;}&-icon{border:1px ", ";width:", "px;height:", "px;line-height:", "px;vertical-align:middle;text-align:center;border-radius:", ";font-size:", ";transition:background-color 0.3s,border-color 0.3s;", "{line-height:1;font-size:", ";position:relative;}}&-tail{position:absolute;left:0;top:", "px;left:calc(50% + ", "px);right:calc(-50% + ", "px);&:after{content:'';display:block;background:", ";height:", ";width:100%;transition:background 0.3s;}}&-content{margin-top:3px;}&-title{font-size:", ";line-height:", ";margin-bottom:", ";display:inline-block;padding-right:10px;position:relative;color:", ";&:after{content:'';height:1px;width:1000px;background:", ";display:block;position:absolute;top:0.55em;left:100%;}}&-description{font-size:", ";line-height:", ";color:", ";}", " ", " ", " ", "}.", "{.", "-item{margin-right:10px;flex-direction:row;align-items:start;&:last-child{flex:none;}&-title{line-height:24px;&:after{top:50%;}}&-container{flex-direction:row;align-items:start;}&-content{margin-top:0px;}&:last-child{margin-right:0;}&-tail{display:none;}&-icon{margin-right:8px;}&-description{max-width:100px;}}&.", "-small{.", "-item-icon{margin-top:4px;}}}", "  ", " ", " ", ""], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.steps.padding;
}, function (props) {
  return props.theme.steps.background;
}, function (props) {
  return props.theme.steps.border;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.steps.hoverBackgroundColor;
}, function (props) {
  return props.theme.steps.hoverBackgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.steps.status.wait.borderColor;
}, function (props) {
  return props.theme.steps.size.normal.circleSize;
}, function (props) {
  return props.theme.steps.size.normal.circleSize;
}, function (props) {
  return props.theme.steps.size.normal.circleSize;
}, function (props) {
  return props.theme.steps.size.normal.borderRadius;
}, function (props) {
  return props.theme.steps.size.normal.stepNumberSize;
}, _StyledIcon.default, function (props) {
  return props.theme.steps.size.normal.iconSize;
}, function (props) {
  return props.theme.steps.size.normal.circleSize / 2;
}, function (props) {
  return props.theme.steps.size.normal.circleSize / 2;
}, function (props) {
  return props.theme.steps.size.normal.circleSize / 2;
}, function (props) {
  return props.theme.steps.tailColor;
}, function (props) {
  return props.theme.steps.tailSize;
}, function (props) {
  return props.theme.steps.size.normal.titleFontSize;
}, function (props) {
  return props.theme.steps.size.normal.titleLineHeight;
}, function (props) {
  return props.theme.steps.titleDescriptionGap;
}, function (props) {
  return props.theme.steps.status.wait.textColor;
}, function (props) {
  return props.theme.steps.tailColor;
}, function (props) {
  return props.theme.steps.size.normal.descriptionFontSize;
}, function (props) {
  return props.theme.steps.size.normal.descriptionLineHeight;
}, function (props) {
  return props.theme.steps.status.wait.textColor;
}, function (props) {
  return (0, _StyledFeatures.FeatureStatus)(props.theme, 'wait', props.prefixCls);
}, function (props) {
  return (0, _StyledFeatures.FeatureStatus)(props.theme, 'process', props.prefixCls);
}, function (props) {
  return (0, _StyledFeatures.FeatureStatus)(props.theme, 'finish', props.prefixCls);
}, function (props) {
  return (0, _StyledFeatures.FeatureStatus)(props.theme, 'error', props.prefixCls);
}, function (props) {
  return "".concat(props.prefixCls, "-horizontal:not(.").concat(props.prefixCls, "-label-vertical)");
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return (0, _StyledFeatures.FeatureProgressDot)(props.theme, props.prefixCls);
}, function (props) {
  return (0, _StyledFeatures.FeatureSmall)(props.theme, props.prefixCls);
}, function (props) {
  return (0, _StyledFeatures.FeatureVertical)(props.theme, props.prefixCls);
}, function (props) {
  return (0, _StyledFeatures.FeatureLabelPlacement)(props.theme, props.prefixCls);
});
var StepsContainer = exports.StepsContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-yafiiu-1"
})([""]);